// frontend/src/site/templates/TemplateCorretorLovable/components/ServicesSection.jsx
import {
  Home,
  Key,
  Building,
  MessageSquare,
  TrendingUp,
  FileCheck,
} from 'lucide-react';

const services = [
  {
    icon: Home,
    title: 'Compra de Imóveis',
    description:
      'Encontro o imóvel ideal para você, com análise completa de mercado e negociação estratégica.',
  },
  {
    icon: Key,
    title: 'Venda de Imóveis',
    description:
      'Avaliação precisa, marketing profissional e estratégias para vender pelo melhor valor.',
  },
  {
    icon: Building,
    title: 'Locação',
    description:
      'Gestão completa de locação, desde a busca de inquilinos até a administração do contrato.',
  },
  {
    icon: TrendingUp,
    title: 'Investimentos',
    description:
      'Consultoria especializada para identificar as melhores oportunidades de investimento imobiliário.',
  },
  {
    icon: FileCheck,
    title: 'Assessoria Jurídica',
    description:
      'Análise documental completa e suporte jurídico para transações seguras.',
  },
  {
    icon: MessageSquare,
    title: 'Consultoria',
    description:
      'Orientação personalizada para todas as suas dúvidas sobre o mercado imobiliário.',
  },
];

const ServicesSection = () => {
  return (
    <section id="servicos" className="py-24 lg:py-32 bg-section-testimonials">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-gold font-medium tracking-wider text-sm uppercase mb-4">
            Como Posso Ajudar
          </p>
          <h2 className="font-serif text-4xl lg:text-5xl font-semibold text-foreground leading-tight mb-6">
            Serviços Especializados
          </h2>
          <p className="text-muted-foreground">
            Ofereço uma gama completa de serviços para atender todas as suas
            necessidades no mercado imobiliário.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="group p-8 bg-card rounded-2xl border border-border hover:border-gold transition-all duration-300 hover:shadow-medium cursor-pointer"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className="w-14 h-14 bg-gold/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-gold group-hover:shadow-gold transition-all duration-300">
                <service.icon className="w-7 h-7 text-gold group-hover:text-primary-foreground transition-colors" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-foreground mb-3 group-hover:text-gold transition-colors">
                {service.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
